import {PropsWithChildren} from "react";
import { observer } from "mobx-react";
import { useStores } from "hooks/useStores";
import {Navbar} from "../../components/business/Nav";
import {Footer} from "../../components/business/Footer";
import { Feedback } from "components/business/Feedback";
import * as S from './styles'

export const BusinessLayout = observer(({children}: PropsWithChildren<unknown>) => {
  const { businessStore } = useStores()

  const showFeedback = businessStore.getShowFeedback

  return (
      <S.Layout>
          <Navbar/>
          <S.Content>
              {children}
          </S.Content>
          <Footer/>
          {showFeedback && <Feedback/>}
      </S.Layout>
  )
})